<template>
  <!-- Account FAB top right -->
  <v-layout class="p-relative">
    <v-menu
      transition="scale-transition"
      origin="top right"
      content-class="notification-dropdown"
      :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn
        class="mr-0"
          fab small light
          v-on="on"
          @click.native.stop="notificationToggle = !notificationToggle">
          <font-awesome-icon size="lg" icon="bell"></font-awesome-icon>
        </v-btn>
      </template>
      <v-flex elevation-4 class="notification-menu" :class="{'mobile': $vuetify.breakpoint.smAndDown}">
        <div v-if="notifications.length > 0" class="pa-2 text-xs-right" style="border-bottom: 1px solid rgba(255,255,255,0.12);">
          <v-btn @click="clearAllNotifications()" flat dark small class="ma-0">
            <v-icon class="mr-2" small>clear_all</v-icon>Clear all
          </v-btn>
        </div>
        <div v-if="notifications.length === 0" class="d-flex align-center justify-center" style="min-height: 120px; padding: 24px;">
          <p class="body-1 white--text text-xs-center" style="opacity: 0.7; margin: 0;">No new notifications.</p>
        </div>
        <div v-for="(notification, index) in notifications" :key="index">
          <fab-notification :notification="notification" :icon="getIcon(notification.eventType)"></fab-notification>
          <v-divider dark></v-divider>
        </div>
        <!-- <v-layout row wrap pa-2>
          <v-flex xs9 pl-1>
            <div style="display:table-cell; vertical-align:middle;">
              <v-avatar style="float:left;" class="mt-0 mr-2" color="warning" size="30px">
                <v-icon small dark>alarm</v-icon>
              </v-avatar>
            </div>
            <div style="display:table-cell" class="pl-1">
              <h4 style="line-height:1.3em">Service level warning</h4>
              <span class="body-1 opacity-54">Lorem ipsum</span>
            </div>
          </v-flex>
          <v-flex xs3 text-xs-right class="mt-0">
            <div
              class="body-1 opacity-54"
              style="display:inline-flex; vertical-align:top !important; margin-top:9px"
            >15:26</div>
            <v-btn dark small class="mr-0 ml-2" icon>
              <v-icon small color="white">cancel</v-icon>
            </v-btn>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" dark small class="mr-0 ml-0 pa-0" icon>
                  <v-icon small color="white">more_vert</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-tile @click="clicked">
                  <v-icon class="mr-2" color="secondary">notifications_off</v-icon>Turn off notifications on this case
                </v-list-tile>
                <v-list-tile @click="clicked">
                  <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications on this case
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-divider dark></v-divider>
        <v-layout row wrap pa-2>
          <v-flex xs9 pl-1>
            <div style="display:table-cell; vertical-align:middle;">
              <v-avatar style="float:left;" class="mt-0 mr-2" color="white" size="30px">
                <v-icon small color="secondary">fas fa-info</v-icon>
              </v-avatar>
            </div>
            <div style="display:table-cell" class="pl-1">
              <h4 style="line-height:1.3em">Service level warning</h4>
              <span class="body-1 opacity-54">Lorem ipsum</span>
            </div>
          </v-flex>
          <v-flex xs3 text-xs-right class="mt-0">
            <div
              class="body-1 opacity-54 mr-1"
              style="display:inline-flex; vertical-align:top !important; margin-top:9px"
            >15:26</div>
            <v-btn dark small class="mr-0 ml-2" icon>
              <v-icon small color="white">cancel</v-icon>
            </v-btn>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" dark small class="mr-0 ml-0 pa-0" icon>
                  <v-icon small color="white">more_vert</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-tile @click="clicked">
                  <v-icon class="mr-2" color="secondary">notifications_off</v-icon>Turn off notifications on this case
                </v-list-tile>
                <v-list-tile @click="clicked">
                  <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications on this case
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-menu>

    <div v-if="notifications.length > 0" class="fab-alert-counter">
      <span>{{notificationCountDisplay}}</span>
    </div>
    <v-speed-dial
      v-model="fabProfile" open-on-hover
      direction="bottom" transition="slide-y-transition">
      <v-btn slot="activator"  v-model="fabProfile" color="primary" fab small aria-label="profile-menu" class=" fab-profile">
        <UserAvatar
          :user-id="user.id"
          avatarOnly
          status="active"
          :name="user.displayName"
          size="40px"
          >
        </UserAvatar>
      </v-btn>
      <v-tooltip left color="secondary">
        <v-btn slot="activator" fab small color="secondary" dark @click="editUser">
          <v-icon>person</v-icon>
        </v-btn>
        <span>Edit Profile</span>
      </v-tooltip>
      <v-tooltip left color="error">
        <v-btn slot="activator" fab small color="error" @click="logout" aria-label="logout">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
        <span>Logout</span>
      </v-tooltip>
    </v-speed-dial>
  </v-layout>
</template>

<script>
import { lookupByEventType } from "@/stores/timeline/eventTypes"
import UserAvatar from "@/components/Users/UserAvatar.vue"
import FabNotification from '@/components/notifications/FabNotification'
import { mapState } from 'vuex'

export default {
  name: "AccountFAB",
  components: { UserAvatar, FabNotification },
  data: () => ({
    fabProfile: false,
    notificationMenu: false,
    notificationToggle: false,
    notificationIcons: {
      "case.read": {
        icon: "visibility",
        iconClass: "indigo white--text"
      },
      "case.state.changed": {
        icon: "flare",
        iconClass: "blue lighten-1 white--text"
      },
      "case.updated": {
        icon: "cached",
        iconClass: "cyan lighten-1 white--text"
      },
      "case.created": {
        icon: "note_add",
        iconClass: "green lighten-1 white--text"
      },
      "case.deleted": {
        icon: "remove_circle",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "task.created": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "task.updated": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "task.deleted": {
        icon: "close",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "task.executed": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "tasklist.created": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "tasklist.updated": {
        icon: "check",
        iconClass: "orange darken-1 white--text" // NEW
      },
      "tasklist.deleted": {
        icon: "close",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "document.uploaded": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.updated": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.deleted": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.viewed": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.downloaded": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.duplicated": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.copied": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.moved": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "case.note.created": {
        icon: "note_add",
        iconClass: "green lighten-1 white--text"
      },
      "case.note.updated": {
        icon: "cached",
        iconClass: "cyan lighten-1 white--text"
      },
      "case.note.deleted": {
        icon: "remove_circle",
        iconClass: "red lighten-1 white--text"
      },
      "conversation.received": {
        icon: "message",
        iconClass: "orange darken-2 white--text" // New
      },
      "conversation.created": {
        icon: "message",
        iconClass: "orange darken-2 white--text"
      },
      "conversation.replied": {
        icon: "reply",
        iconClass: "blue darken-2 white--text"
      },
      "conversation.read": {
        icon: "message",
        iconClass: "orange darken-2 white--text"
      },
      "conversation.attached": {
        icon: "attach_file",
        iconClass: "orange darken-2 white--text"
      },
      email_reply_received: {
        icon: "reply",
        iconClass: "blue darken-2 white--text"
      },
      reindex_started: {
        icon: "autorenew",
        iconClass: "orange darken-2 white--text" // New
      },
      reindex_finished: {
        icon: "autorenew",
        iconClass: "orange darken-2 white--text" // New
      },
      reindex_failed: {
        icon: "error",
        iconClass: "red darken-2 white--text"
      },
      export_started: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      export_batch_progress: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      export_finished: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      import_started: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      import_finished: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      error: {
        icon: "close",
        iconClass: "red darken-2 white--text" // New
      },
      email_receive_failed: {
        icon: "email",
        iconClass: "red darken-2 white--text"
      },
      email_receive_recovered: {
        icon: "email",
        iconClass: "green darken-2 white--text"
      },
      "timeline.custom": {
        icon: "timeline",
        iconClass: "orange darken-1 white--text"
      },
      default: {
        icon: "timeline",
        iconClass: "grey lighten-1 white--text"
      }
    }
  }),
  computed: {
    ...mapState({
      notifications: state => state.currentUser.notifications,
      user: state => state.currentUser.me
    }),
    notificationCount() {
      if (this.notifications) {
        return this.notifications.length
      } else {
        return 0
      }
    },
    notificationCountDisplay() {
      const count = this.notificationCount
      return count > 99 ? '99+' : count
    }
  },
  methods: {
    getIcon(type) {
      const entry = lookupByEventType(this.notificationIcons, type) || this.notificationIcons.default
      return entry.icon
    },
    logout() {
      this.$store.dispatch("logout")
      this.$router.push("/")
    },
    editUser() {
      this.$router.push({ name: "UserProfile", params: { tab: "Profile" } })
    },
    clearAllNotifications() {
      this.$store.dispatch("clearAllNotifications")
    }
  }
}
</script>

<style>
.fab-alert-counter {
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background: rgb(219, 68, 77);
  background: -moz-linear-gradient(
    top,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  ) !important;
  background: -webkit-linear-gradient(
    top,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  );
  z-index: 999;
  top: 6px;
  left:3px;
  font-size: 10px;
  color: white;
}

.fab-alert-counter span {
  text-align: center;
  width: 100%;
  display: block;
  padding: 1px 0 0 0;
}

.notification-latest-icon {
  position: absolute !important;
  top: -20px !important;
  left: 28px !important;
  z-index: 99;
  opacity: 1 !important;
  transform: rotate(0deg) !important;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background: rgb(219, 68, 77);
  background: -moz-linear-gradient(
    top,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  ) !important;
  background: -webkit-linear-gradient(
    top,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(219, 68, 77, 1) 0%,
    rgba(175, 31, 46, 1) 100%
  );
}

.notification-menu {
 background: #1d303e;
    background: -webkit-gradient(linear, left top, left bottom, from(#1d303e), to(#121f29));
    background: linear-gradient(180deg, #1d303e 0%, #121f29 100%);
  color: white;
  border-radius: 5px;
}

.casework-toggled .notification-menu {
  background: rgb(86, 86, 86); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(86, 86, 86, 1) 0%,
    rgba(56, 56, 56, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(86, 86, 86, 1) 0%,
    rgba(56, 56, 56, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(86, 86, 86, 1) 0%,
    rgba(56, 56, 56, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.notification-dropdown.v-menu__content {
  position: fixed !important;
  top: 66px !important;
  right: 16px !important;
  left: initial !important;
  width: calc(100% - 32px);
  max-height: 400px;
  transform-origin: top right !important;
  max-width: 500px;
}

.fab-profile .v-avatar {
  background:white !important;
}

.fab-profile .v-avatar span {
  color:#101b23 !important
}

</style>
